/**
 * @module builder
 */
import type { QuoteDocument, AreaSubstrate, OptionsDocument } from 'paintscout'

import findIndex from 'lodash/findIndex'

import { generateAreaDescription } from '../util/generate-area-description/generate-area-description'
import { calculateQuote } from '../util/calculate/calculate-quote'

export function removeAreaSubstrate(args: {
  quote: QuoteDocument
  options: OptionsDocument
  areaKey: string
  key: string
}): QuoteDocument {
  const { quote, options, areaKey, key } = args

  if (!quote.areas[areaKey]) {
    return quote
  }

  const substrates = { ...quote.areas[areaKey].substrates }

  Object.keys(substrates).forEach((section) => {
    const index = findIndex(substrates[section], { key })
    if (index !== -1) {
      substrates[section] = substrates[section].filter((substrate: AreaSubstrate) => substrate.key !== key)
    }
  })

  const substrateOrder = quote.areas[areaKey].substrateOrder.filter((item) => item.key !== key)

  const updatedQuote = {
    ...quote,
    areas: {
      ...quote.areas,
      [areaKey]: {
        ...quote.areas[areaKey],
        substrateOrder,
        substrates,
        substrate_string: {
          ...quote.areas[areaKey].substrate_string
        }
      }
    }
  }
  updatedQuote.areas[areaKey].substrate_string.default = generateAreaDescription({
    quote: updatedQuote,
    options,
    areaKey
  })

  return calculateQuote({ quote: updatedQuote, options })
}
